import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import PublicIcon from '@mui/icons-material/Public';
import FavoriteIcon from '@mui/icons-material/Favorite';
import GavelIcon from '@mui/icons-material/Gavel';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const About = () => {
  return (
    <Box
      sx={{
        minHeight: '80vh',
        py: 8,
        background:
          'radial-gradient(circle at top left, #fffbeb 0%, #ffffff 40%, #e5f2ff 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          component="h1"
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            mb: 2,
            color: '#f97316',
          }}
        >
          About GBCN Foundation
        </Typography>
        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
            mb: 6,
            maxWidth: '800px',
            mx: 'auto',
          }}
        >
          A social organization committed to transparent governance, community participation, and digital accountability
        </Typography>

        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 3, color: '#111827' }}
          >
            Our Vision
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 4 }}>
          To build a strong, educated, culturally rooted, and socially responsible community by empowering students, youth, and women, preserving Indian Sanskriti, and enabling inclusive growth through knowledge, mentorship, and ethical leadership.
          GBCN Foundation envisions a society where education leads to empowerment, culture strengthens identity, and community collaboration drives sustainable social transformation.
          </Typography>

          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 3, color: '#111827', mt: 4 }}
          >
            Our Mission
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 4 }}>
          The mission of GBCN Foundation is to translate vision into action by:
Promoting quality education, scholarships, and structured mentorship for students
Empowering youth and women through leadership development, skill enhancement, and self-reliance initiatives
Preserving and promoting Indian culture, values, and traditions (Sanskriti)
Creating a transparent, technology-enabled community platform for collaboration, support, and social impact
Supporting career guidance, entrepreneurship, and professional growth
Strengthening community welfare, social responsibility, and volunteerism
Operating with integrity, accountability, and non-profit principles in alignment with national interest
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 3, color: '#111827', mt: 4 }}
          >
            Core Belief
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 4 }}>
          When education empowers, culture guides, and community unites — nation building becomes inevitable
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 3, color: '#111827', mt: 4 }}
          >
            Focus Areas
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 4 }}>
          Education | Youth Empowerment | Women Empowerment | Student Mentorship | Cultural Preservation | Community Development | Digital Transparency
Short Tagline (Optional)
“Empowering Minds • Preserving Values • Building Community”
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 3, color: '#111827', mt: 4 }}
          >
            Our Objectives
          </Typography>
        
          <Grid container spacing={2} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • Promote education through scholarships and mentorship programs
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • Empower women through skill development and leadership initiatives
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • Support youth through career guidance and development programs
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • Preserve and promote Indian Sanskriti and cultural heritage
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • Ensure transparent financial governance and accountability
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • Build a strong, connected community through digital platforms
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: '100%',
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb',
                '&:hover': {
                  boxShadow: '0 8px 24px rgba(249, 115, 22, 0.15)',
                },
              }}
            >
              <CardContent>
                <HistoryIcon
                  sx={{ fontSize: 48, color: '#f97316', mb: 2 }}
                />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#111827' }}>
                  Our History
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Founded with a vision to create positive social impact through education, culture, and empowerment initiatives.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: '100%',
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb',
                '&:hover': {
                  boxShadow: '0 8px 24px rgba(249, 115, 22, 0.15)',
                },
              }}
            >
              <CardContent>
                <GavelIcon
                  sx={{ fontSize: 48, color: '#f97316', mb: 2 }}
                />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#111827' }}>
                  Legal Status
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Registered as a social organization, committed to compliance and transparent governance practices.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: '100%',
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb',
                '&:hover': {
                  boxShadow: '0 8px 24px rgba(249, 115, 22, 0.15)',
                },
              }}
            >
              <CardContent>
                <VerifiedUserIcon
                  sx={{ fontSize: 48, color: '#f97316', mb: 2 }}
                />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#111827' }}>
                  Transparency
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  All donations and expenses are tracked and made visible to members through our transparency dashboard.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, mb: 3, color: '#111827' }}
          >
            Our Values
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • <strong>Transparency:</strong> Open and accountable governance
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • <strong>Community:</strong> Building strong, connected networks
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • <strong>Education:</strong> Empowering through knowledge
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • <strong>Empowerment:</strong> Supporting women and youth
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • <strong>Culture:</strong> Preserving our rich heritage
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                • <strong>Accountability:</strong> Digital transparency in all activities
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default About;
